<template>
  <div class="d-print-none">
    <v-menu v-if="canCommitFeiActions" min-width="120px" nudge-bottom="20">
      <template #activator="{ props }">
        <v-btn-icon
          color="primary"
          size="x-small"
          variant="outlined"
          class="ma-0"
          :disabled="disabled"
          :aria-label="$t('events:EventPage.Dashboard.actionsButton.alt')"
          v-bind="props"
        >
          <v-icon color="primary"> $iconEllipsisV </v-icon>
        </v-btn-icon>
      </template>

      <v-list>
        <v-list-item
          v-if="$allowedMutation(entry.allowedMutations, 'entryWithdraw')"
          @click="() => entryFeiActionOpener('entryWithdraw', { entry })"
        >
          {{ $t("events:entryAction.withdraw.action.label", "Withdraw") }}
        </v-list-item>

        <v-list-item
          v-if="
            $allowedMutation(entry.allowedMutations, 'entrySpecifyHorseForSlot')
          "
          @click="
            () => entryFeiActionOpener('entrySpecifyHorseForSlot', { entry })
          "
        >
          {{
            $t(
              "events:entryAction.specifyHorseForSlot.action.label",
              "Select horse for slot"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="$allowedMutation(entry.allowedMutations, 'entryAccept')"
          @click="() => entryFeiActionOpener('entryAccept', { entry })"
        >
          {{
            $t(
              "events:entryAction.acceptEntry.action.label",
              "Accept entry (OC)"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="$allowedMutation(entry.allowedMutations, 'entryReject')"
          @click="() => entryFeiActionOpener('entryReject', { entry })"
        >
          {{ $t("events:entryAction.entryRejectForm.action.label", "Reject") }}
        </v-list-item>

        <v-list-item
          v-if="
            $allowedMutation(entry.allowedMutations, 'entryReturnToWaiting')
          "
          @click="() => entryFeiActionOpener('entryReturnToWaiting', { entry })"
        >
          {{
            $t(
              "events:entryAction.entryReturnToWaitingForm.action.label",
              "Return to waiting"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="
            $allowedMutation(entry.allowedMutations, 'entryApproveCandidacy')
          "
          @click="
            () => entryFeiActionOpener('entryApproveCandidacy', { entry })
          "
        >
          {{
            $t(
              "events:entryAction.approveCandidacy.action.label",
              "Approve candidacy"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="
            $allowedMutation(entry.allowedMutations, 'entryReserveCandidacy')
          "
          @click="
            () => entryFeiActionOpener('entryReserveCandidacy', { entry })
          "
        >
          {{ $t("events:entryAction.markReserve.action.label", "Reserve") }}
        </v-list-item>

        <v-list-item
          v-if="
            $allowedMutation(entry.allowedMutations, 'entryRejectCandidacy')
          "
          @click="() => entryFeiActionOpener('entryRejectCandidacy', { entry })"
        >
          {{ $t("events:entryAction.rejectCandidacy.action.label", "Reject") }}
        </v-list-item>

        <v-list-item
          v-if="
            $allowedMutation(entry.allowedMutations, 'entryReturnToCandidacy')
          "
          @click="
            () => entryFeiActionOpener('entryReturnToCandidacy', { entry })
          "
        >
          {{
            $t(
              "events:entryAction.returnToCandidacy.action.label",
              "Return to candidacy"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="$allowedMutation(entry.allowedMutations, 'entryUnregister')"
          @click="() => entryFeiActionOpener('entryUnregister', { entry })"
        >
          {{ $t("events:entryAction.unregister.action.label", "Delete") }}
        </v-list-item>

        <v-list-item
          v-if="canUpdateEntryPaidExternally"
          @click="
            () => entryFeiActionOpener('entryUpdatePaidExternally', { entry })
          "
        >
          {{
            $t(
              "events:entryAction.paymentOptions.action.label",
              "Payment options"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="$allowedMutation(entry.allowedMutations, 'entryUpdateNotes')"
          @click="() => entryFeiActionOpener('entryUpdateNotes', { entry })"
        >
          {{
            $t(
              "events:entryAction.setNotesForEntry.action.label",
              "Add and edit notes for entry"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="beddingTypeChangeable"
          @click="
            () =>
              entryFeiActionOpener('registrationHorseUpdateBeddingType', {
                entry
              })
          "
        >
          {{ $t("events:entryAction.beddingOnHorse.action.label", "Bedding") }}
        </v-list-item>

        <v-list-item
          v-if="$allowedMutation(entry.allowedMutations, 'entryUpdateDetails')"
          @click="
            () =>
              entryFeiActionOpener('entryUpdateDetails', {
                entry
              })
          "
        >
          {{
            $t(
              "events:entryAction.editAdditionalDetails.action.label",
              "Edit details"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="canEntryAddRegistrationEventProduct"
          @click="
            () =>
              entryFeiActionOpener('entryAddRegistrationEventProduct', {
                entry
              })
          "
        >
          {{
            $t(
              "events:entryAction.entryAddRegistrationEventProduct.action.label",
              "Add product fee"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="canConfirmEntry"
          @click="
            () =>
              entryFeiActionOpener('entryConfirm', {
                entry
              })
          "
        >
          {{
            $t("events:entryAction.entryConfirm.action.label", "Confirm entry")
          }}
        </v-list-item>

        <v-list-item
          v-if="canSubstituteHorse"
          @click="
            () =>
              entryFeiActionOpener('registrationSubstituteHorses', {
                entry
              })
          "
        >
          {{
            $t(
              "events:entryAction.registrationSubstituteHorses.action.label",
              "Substitute horse"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="canSubstituteAthlete"
          @click="
            () =>
              entryFeiActionOpener('registrationSubstituteAthletes', {
                entry
              })
          "
        >
          {{
            $t(
              "events:entryAction.registrationSubstituteAthletes.action.label",
              "Substitute athlete"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="
            $allowedMutation(
              entry.allowedMutations,
              'entryCreateOrUpdateBillingContact'
            )
          "
          @click="
            () =>
              entryFeiActionOpener('entryCreateOrUpdateBillingContact', {
                entry
              })
          "
        >
          {{
            $t(
              "events:entryAction.editBillingContact.action.label",
              "Billing contact"
            )
          }}
        </v-list-item>

        <v-list-item
          v-if="$allowedMutation(entry.allowedMutations, 'entryOrderProduct')"
          @click="
            () =>
              entryFeiActionOpener('entryOrderProduct', {
                entry
              })
          "
        >
          {{ $t("events:entryAction.applyFee.action.label", "Apply fees") }}
        </v-list-item>

        <v-list-item
          v-if="canEditRegistration"
          :to="{
            name: 'EventMultiRegistrationPage',
            params: {
              eventId: registration.eventId
            }
          }"
        >
          {{ $t("events:entryAction.toEntryForm.action.label", "Entry form") }}
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-else>
      <slot name="no-actions" />
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import { gql as ApolloGql } from "@apollo/client/core";
import { apolloClient } from "@/plugins/apollo";
import { inject, computed } from "vue";
import allowedMutation from "@/utils/allowedMutation";

export default {
  name: "EntryFeiActionsMenu",
  props: {
    entry: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const entryFeiActionOpener = inject("EntryFeiActionOpener", () => {
      console.warn("EntryFeiActionoOpener not provided!");
    });

    const registration = apolloClient.readFragment({
      id: `Registration:${props.entry.registrationId}`,
      fragment: ApolloGql`
        fragment EntryFeiActionsMenuGetRegistration on Registration {
          id
          eventId
          athletes {
            id
          }
          registrationHorses {
            id
            allowedMutations
          }
          allowedMutations
        }
      `
    });

    const event = apolloClient.readFragment({
      id: `Event:${registration.eventId}`,
      fragment: ApolloGql`
        fragment EntryFeiActionsMenuGetEvent on Event {
          id
          allowedMutations
        }
      `
    });

    const beddingTypeChangeable = computed(() => {
      return (
        registration.registrationHorses?.some(regHorse =>
          allowedMutation(
            regHorse.allowedMutations,
            "registrationHorseUpdateBeddingType"
          )
        ) ?? false
      );
    });
    const canEditRegistration = computed(() => {
      return allowedMutation(
        event.allowedMutations ?? [],
        "multiRegistrationCreateOrUpdate"
      );
    });

    const canSubstituteHorse = computed(() => {
      return allowedMutation(
        registration.allowedMutations ?? [],
        "registrationSubstituteHorses"
      );
    });

    const canSubstituteAthlete = computed(() => {
      return allowedMutation(
        registration.allowedMutations ?? [],
        "registrationSubstituteAthletes"
      );
    });

    const canUpdateEntryPaidExternally = computed(() => {
      return allowedMutation(
        props.entry.allowedMutations ?? [],
        "entryUpdatePaidExternally"
      );
    });

    const canEntryAddRegistrationEventProduct = computed(() => {
      return allowedMutation(
        props.entry.allowedMutations ?? [],
        "entryAddRegistrationEventProduct"
      );
    });

    const canCommitFeiActions = computed(() => {
      return (
        canUpdateEntryPaidExternally.value ||
        canEditRegistration.value ||
        beddingTypeChangeable.value ||
        canEntryAddRegistrationEventProduct.value ||
        allowedMutation(props.entry.allowedMutations, [
          "entryReturnToWaiting",
          "entryReject",
          "entryAccept",
          "entryCreateOrUpdateBillingContact",
          "entryWithdraw",
          "entrySpecifyHorseForSlot",
          "entryApproveCandidacy",
          "entryReserveCandidacy",
          "entryRejectCandidacy",
          "entryUnregister",
          "entryReturnToCandidacy",
          "entryUpdateNotes",
          "entryOrderProduct",
          "entryUpdateDetails"
        ]) ||
        canSubstituteHorse.value ||
        canSubstituteAthlete.value ||
        canConfirmEntry.value
      );
    });

    const canConfirmEntry = computed(() => {
      return allowedMutation(
        props.entry.allowedMutations ?? [],
        "entryConfirm"
      );
    });

    return {
      registration,

      canUpdateEntryPaidExternally,
      canCommitFeiActions,
      canSubstituteHorse,
      canEditRegistration,
      beddingTypeChangeable,
      canSubstituteAthlete,

      entryFeiActionOpener,
      canConfirmEntry,
      canEntryAddRegistrationEventProduct
    };
  },
  fragments: {
    athleteFields: gql`
      fragment _ on Person {
        id
      }
    `,
    registrationFields: gql`
      fragment _ on Registration {
        eventId
        athletes {
          id
        }
        registrationHorses {
          id
          allowedMutations
        }
        allowedMutations
      }
    `,
    entryFields: gql`
      fragment _ on Entry {
        registrationId
        allowedMutations
      }
    `,
    eventFields: gql`
      fragment _ on Event {
        id
        allowedMutations
      }
    `,
    registrationHorseFields: gql`
      fragment _ on RegistrationHorse {
        id
        allowedMutations
      }
    `
  }
};
</script>
